// Real trigger wiring, state machine, and real matching algorithm
// (Part 2b) for the search takeover.
//
// Two trigger sites, one shared takeover instance (rendered once,
// site-wide, from layout/theme.liquid so it's reachable from both):
// the standard nav's search icon (snippets/makc-nav-standard.liquid,
// most pages) and the Menu page's own toolbar search bar (snippets/
// makc-menu-toolbar.liquid, Menu page only -- the nav variant used
// there has no search icon of its own). Both carry
// data-makc-search-trigger; this file doesn't care which one was
// tapped, matching the shared-trigger pattern already used for the
// product sheet/notify-me modal.
//
// Scroll-lock lives in the shared assets/makc-scroll-lock.js, loaded
// site-wide from layout/theme.liquid before this script -- see that
// file for why it's shared rather than a local implementation here.
//
// Three live states now, not four -- State 3 (__found) is gone,
// collapsed into State 2 (see snippets/makc-search-takeover.liquid's
// own comment for the full reasoning: suggestions were the only thing
// that ever distinguished them, and suggestions are gone). Every
// non-empty query with at least one match shows __typing.
//
// Close resets to a fresh State 1 (input cleared, __popular shown) --
// matches this build's own established "grid always opens fresh"
// pattern (the product sheet's own resetSheet()), confirmed as the
// intended behaviour before building it this way, not a silent
// assumption.
(function () {
  var takeover = document.querySelector('[data-makc-search-takeover]');
  if (!takeover) return;

  var triggers = document.querySelectorAll('[data-makc-search-trigger]');
  if (!triggers.length) return;

  var MAX_RESULTS = 5;

  var closeButton = takeover.querySelector('[data-makc-search-close]');
  var input = takeover.querySelector('[data-makc-search-input]');
  var clearButton = takeover.querySelector('[data-makc-search-clear]');
  var popularBlock = takeover.querySelector('[data-makc-search-popular]');
  var typingBlock = takeover.querySelector('[data-makc-search-typing]');
  var noResultsBlock = takeover.querySelector('[data-makc-search-no-results]');
  var typingResults = takeover.querySelector('[data-makc-search-typing-results]');
  var showAllTemplate = takeover.querySelector('[data-makc-search-show-all-template]');

  // Catalogue parsed once, on load, from the site-wide JSON export
  // (snippets/makc-search-catalogue.liquid, rendered from
  // layout/theme.liquid). Falls back to an empty array on a missing
  // element or malformed JSON rather than throwing -- search degrades
  // to "always zero results" instead of breaking the whole takeover.
  var catalogue = [];
  var catalogueEl = document.querySelector('[data-makc-search-catalogue]');
  if (catalogueEl) {
    try {
      catalogue = JSON.parse(catalogueEl.textContent) || [];
    } catch (e) {
      catalogue = [];
    }
  }

  function open() {
    // Re-entry guard. Without it a second open() while already open
    // takes a second shared scroll lock, and the single close() that
    // follows only releases one -- leaving the page unscrollable with
    // no overlay on screen. Reachable by keyboard at every breakpoint:
    // the nav/toolbar search triggers stay focusable behind the
    // takeover (and, from 768px up, behind the modal's backdrop), so
    // Tab + Enter can fire this twice. Found while verifying the
    // 768px modal; pre-existing, one line, fixed here rather than
    // left for a later branch to trip over.
    if (!takeover.hidden) return;
    takeover.hidden = false;
    window.makcScrollLock.lock();
  }

  // The takeover now fades out (assets/makc-search-takeover.css), so it
  // is still on screen for 200ms after hidden is set -- long enough to
  // watch the query empty itself and the results flip back to Popular.
  // Both are reset after the exit instead (CLAUDE.md "Motion"). The
  // unlock always runs once scheduled, or a reopen mid-exit would
  // strand a scroll lock; the visible resets are skipped if the
  // takeover came back, since they would then be wiping a live search.
  function close() {
    takeover.hidden = true;
    function tail() {
      window.makcScrollLock.unlock();
      if (!takeover.hidden) return;
      if (input) input.value = '';
      if (clearButton) clearButton.hidden = true;
      showState('popular');
    }
    if (window.makcOverlayExit) window.makcOverlayExit.after(takeover, tail);
    else tail();
  }

  // Shows exactly one of the three state blocks, hiding the rest --
  // mirrors the liquid template's own "parallel, mutually-exclusive
  // blocks" structure (see that file's comment).
  function showState(state) {
    if (popularBlock) popularBlock.hidden = state !== 'popular';
    if (typingBlock) typingBlock.hidden = state !== 'typing';
    if (noResultsBlock) noResultsBlock.hidden = state !== 'no-results';
  }

  // Tap-to-open, shared by every row type (State 1/4's static buttons,
  // wired below, and State 2's dynamically-created ones in
  // renderResultRow). window.makcProductSheet only exists on the Menu
  // page (assets/makc-product-sheet.js only loads there -- see that
  // file's own comment). On the Menu page, behaviour is unchanged from
  // before deep-linking: close the takeover, open the sheet directly.
  // Closes the takeover first, not just opens the sheet on top of it:
  // both are position:fixed, same z-index (200), and the takeover
  // renders AFTER the page's own content in layout/theme.liquid, so
  // without closing it first, a newly-opened sheet would paint
  // underneath the still-visible takeover, not over it. Reuses this
  // file's own close() (input reset, state back to popular) rather than
  // just toggling takeover.hidden directly, for the same "always
  // reopens fresh" reason every other close path here already follows.
  //
  // Off the Menu page, redirects instead of no-op'ing -- see the liquid
  // template's own comment for the full identifier/URL reasoning
  // (product id, not handle; a literal /pages/menu path, not a Liquid
  // pages['menu'].url lookup). The receiving end lives in
  // assets/makc-product-sheet.js, right after window.makcProductSheet
  // is defined -- same file, same script, so there's no cross-file
  // load-order race to worry about by the time it checks the param.
  function openProductSheet(productId) {
    if (!window.makcProductSheet) {
      var menuUrl = takeover.getAttribute('data-makc-menu-url');
      if (!menuUrl) return;
      window.location.href = menuUrl + '?open=' + encodeURIComponent(productId);
      return;
    }
    var opened = window.makcProductSheet.open(String(productId));
    if (opened) close();
  }

  // State 1/4 rows are real, static, server-rendered buttons (see the
  // liquid template's own comment) -- present at page load, so a
  // one-time querySelectorAll + forEach here is correct, matching how
  // this same file already wires the site-wide data-makc-search-trigger
  // elements above.
  var resultTriggers = Array.prototype.slice.call(
    takeover.querySelectorAll('[data-makc-search-result-trigger]')
  );
  resultTriggers.forEach(function (row) {
    row.addEventListener('click', function () {
      openProductSheet(row.getAttribute('data-makc-search-result-trigger'));
    });
  });

  // ---- Matching (Part 2b, the locked algorithm) ------------------------
  //
  // Confirmed canonical list -- the same four category strings already
  // duplicated in snippets/makc-search-catalogue.liquid's own
  // known_categories and snippets/makc-menu-grid.liquid's per-category
  // if-blocks, not retyped from memory (checked both directly). A third
  // copy here stays inside this project's own DRY rule (extract only
  // once a pattern's proven itself in 3+ places) -- and even at that
  // threshold, a shared source would mean bridging Liquid and JS for
  // four static strings, not worth building for this.
  var KNOWN_CATEGORIES = ['Light Bites', 'Mains', 'Made to Order', 'Drinks'];

  // Splits on any run of non-alphanumeric characters, not just spaces
  // -- deliberately, so a hyphenated alias tag like "pepper-goat-meat"
  // and a query typed the same way both decompose into the identical
  // word set (["pepper", "goat", "meat"]) and match each other, rather
  // than needing the query to match the tag as one literal string.
  function tokenize(text) {
    return (text || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  // A field "has" a query token if any WORD in it starts with that
  // token -- prefix match, not substring-anywhere-in-a-word (e.g.
  // "chick" matches "Chicken" because "Chicken" starts with "chick";
  // it would not match a word like "sandchick" under this rule, which
  // substring-anywhere would incorrectly allow).
  function fieldHasToken(fieldText, token) {
    var words = tokenize(fieldText);
    return words.some(function (word) {
      return word.indexOf(token) === 0;
    });
  }

  // Multi-word queries: EVERY token must be found somewhere in the
  // given text, independently -- not adjacent, not in order (e.g.
  // "rice tray" matches as long as both "rice" and "tray" appear
  // somewhere, satisfying the locked spec's "match if all terms are
  // found across the combined fields" rule).
  function allTokensMatch(text, tokens) {
    return tokens.every(function (token) {
      return fieldHasToken(text, token);
    });
  }

  // Shared by getMatchTier below AND matchProducts' own exact-category
  // bypass -- extracted here (not duplicated a second time within this
  // file) since both need the identical gate. window.makcFilters may
  // not exist at all (it's only defined once assets/makc-filter-
  // sheet.js has run, which only loads on the Menu page, where the
  // filter sheet lives) -- treated as "no filters applied" rather than
  // an error, which is exactly correct on every other page, where
  // there's no filter UI to have applied anything from.
  function passesDietaryFilter(product) {
    if (!window.makcFilters) return true;
    var applied = window.makcFilters.getApplied();
    if (!applied || applied.size === 0) return true;
    // AND, matching the Menu grid's applyFiltersToGrid exactly -- see
    // that function's comment for why this was reversed from OR on
    // 2026-09-23. The two must not disagree: the same dish filtered out
    // of the grid must not come back in search.
    var productTags = product.tags || [];
    var passes = true;
    applied.forEach(function (tag) {
      if (productTags.indexOf(tag) === -1) passes = false;
    });
    return passes;
  }

  // Priority tiers per the locked spec: 1 = title, 2 = tags/category,
  // 3 = description. A product is assigned the HIGHEST tier that,
  // considered ALONE, already satisfies every query token -- not
  // simply "which field did a token happen to match in" -- so a
  // product whose title alone contains every term ranks as a title
  // match (tier 1) even if its tags/description would also match,
  // and a product needing tags+category to complete the match (e.g.
  // "jollof" in the title but "tray" only in a tag) correctly lands
  // in tier 2, not tier 1, since title alone doesn't satisfy the full
  // query. menu_category is folded into the tag tier, not its own --
  // confirmed instruction: it's category metadata, not the dish's own
  // identity, so a query like "drinks" or "mains" returns everything
  // in that category at the same priority tier as an alias tag match
  // (this ranked path only -- an EXACT category name takes the
  // uncapped browse path in matchProducts below instead, never
  // reaching here). Returns 0 for no match.
  //
  // Dietary filter intersection: a product must ALSO carry at least
  // one applied tag to be considered at all (checked first, as a
  // gate, before tier logic even runs) -- same OR-within-group
  // semantics makc-filter-sheet.js's own applyFiltersToGrid() already
  // uses for the grid, read via the shared passesDietaryFilter above
  // rather than reimplemented.
  function getMatchTier(product, tokens) {
    if (!passesDietaryFilter(product)) return 0;

    if (allTokensMatch(product.title, tokens)) return 1;

    var tagAndCategoryText = (product.tags || []).join(' ') + ' ' + (product.menu_category || '');
    if (allTokensMatch(tagAndCategoryText, tokens)) return 2;

    var allFieldsText = (product.title || '') + ' ' + tagAndCategoryText + ' ' + (product.description || '');
    if (allTokensMatch(allFieldsText, tokens)) return 3;

    return 0;
  }

  // An EXACT category-name query (case-insensitive, trimmed -- "Drinks"
  // and "drinks" both qualify, but "drink" does not: that's a prefix,
  // not the full category name) is browse intent, not search intent --
  // confirmed decision: it should behave exactly like tapping that
  // category's own toolbar pill on the Menu page (unlimited results),
  // not like a ranked, capped search result. A plain prefix/partial
  // query for a category name (e.g. "drink") still goes through the
  // normal tiered/capped path below and reaches "Drinks" via the
  // existing tag/category tier, same as before this change.
  function isExactCategoryMatch(trimmedQuery) {
    var normalized = trimmedQuery.toLowerCase();
    return KNOWN_CATEGORIES.some(function (category) {
      return category.toLowerCase() === normalized;
    });
  }

  // Powers the "See all in [Category]" row. A prefix can genuinely be
  // ambiguous against the real four KNOWN_CATEGORIES -- not
  // hypothetical: "Mains" and "Made to Order" both start with "m", and
  // still both match at "ma" ("Made to Order" starts with "made", which
  // itself starts with "ma"), only diverging once the query reaches
  // "mad" vs. "mai". Checked directly against the actual four strings,
  // not assumed impossible. Returns the one matching category name, or
  // null for zero matches OR more than one (ambiguous) match. Also
  // returns null for a full exact match (isExactCategoryMatch's own
  // path already surfaces every product in that category unprompted,
  // so a "see all" row pointing at itself would be redundant) -- this
  // function has its own guard for that rather than relying on the
  // input handler to never call it for an exact match, so it stays
  // correct if ever called from elsewhere later.
  function getUniqueCategoryPrefixMatch(trimmedQuery) {
    var normalized = trimmedQuery.toLowerCase();
    if (!normalized) return null;
    var matches = KNOWN_CATEGORIES.filter(function (category) {
      return category.toLowerCase().indexOf(normalized) === 0;
    });
    if (matches.length !== 1) return null;
    if (matches[0].toLowerCase() === normalized) return null;
    return matches[0];
  }

  // Sorts matches into tier order (title, then tag/category, then
  // description) and caps at MAX_RESULTS, per the locked spec's "max 5
  // rows" rule -- taken AFTER priority ordering, not an arbitrary
  // first-5-found. Array#sort is stable in every browser this project
  // targets, so within a tier, results keep the catalogue's own order
  // -- "no further ranking needed" per the spec, nothing extra to
  // build. The exact-category-match branch below skips all of this
  // (tiering, sorting, the cap) entirely -- it's a different intent,
  // not a tier of the same ranked search.
  function matchProducts(query) {
    var trimmedQuery = query.trim();

    if (isExactCategoryMatch(trimmedQuery)) {
      var normalizedCategory = trimmedQuery.toLowerCase();
      return catalogue.filter(function (product) {
        return (product.menu_category || '').toLowerCase() === normalizedCategory && passesDietaryFilter(product);
      });
    }

    var tokens = tokenize(query);
    if (!tokens.length) return [];
    var matches = [];
    catalogue.forEach(function (product) {
      var tier = getMatchTier(product, tokens);
      if (tier > 0) matches.push({ product: product, tier: tier });
    });
    matches.sort(function (a, b) {
      return a.tier - b.tier;
    });
    return matches.slice(0, MAX_RESULTS).map(function (match) {
      return match.product;
    });
  }

  // Matches the existing .makc-search-takeover__row structure exactly
  // (thumbnail + two-line info) -- same classes real Liquid-rendered
  // rows use, so State 2's live-matched rows are visually identical to
  // State 1/4's server-rendered ones. textContent, not innerHTML, for
  // the actual product fields -- catalogue data ultimately comes from
  // this shop's own products, but there's no reason to risk HTML
  // injection via a title/category string when textContent is just as
  // easy.
  //
  // Sold-out items are NOT excluded here (unlike State 1/4's own
  // curated lists, which already exclude them from an earlier,
  // separate decision) -- per the locked spec, search results include
  // sold-out items. Treatment confirmed via Figma (Result Row / Sold
  // Out, node 2037:581 light / 2037:592 dark) as its own distinct
  // component, not the grid card's overlay-scrim pattern adapted down:
  // the tag itself is a plain flex sibling of the thumbnail and info
  // block (not absolutely positioned over anything), and dimming is
  // real opacity on the thumbnail + info elements individually (the
  // --sold-out modifier class below), not a scrim layered on top.
  // Confirmed structurally from the fetched node tree, not assumed
  // from the card's precedent.
  //
  // Tap-to-open: a real <button>, disabled (not click-wired) when
  // sold out -- matches the grid card's own established "a real
  // disabled attribute, not a visual-only treatment" precedent
  // (snippets/makc-menu-card.liquid's own __add button) exactly,
  // rather than inventing a new non-interactive-row pattern for this
  // component. See openProductSheet() above for what a tap actually
  // does.
  function renderResultRow(product) {
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'makc-search-takeover__row';
    row.innerHTML =
      '<div class="makc-search-takeover__thumb"></div>' +
      '<div class="makc-search-takeover__info">' +
      '<p class="makc-search-takeover__name"></p>' +
      '<p class="makc-search-takeover__category"></p>' +
      '</div>';
    // product.image is already null-safe from the catalogue export
    // (snippets/makc-search-catalogue.liquid) -- a real width:100 URL
    // string, or a literal null for a product with nothing uploaded in
    // Admin. Set as a property, not concatenated into the innerHTML
    // string above, matching this function's own established
    // textContent-over-innerHTML caution for product-sourced values.
    // Matches snippets/makc-menu-card.liquid's own image/fallback
    // precedent: appended only when present, leaving the placeholder
    // div's own background-colour showing through otherwise.
    if (product.image) {
      var thumbImage = document.createElement('img');
      thumbImage.className = 'makc-search-takeover__thumb-image';
      thumbImage.src = product.image;
      thumbImage.alt = product.title;
      thumbImage.loading = 'lazy';
      // Result rows are rebuilt on every keystroke -- see
      // assets/makc-image-load.js for why that costs nothing once an
      // image has decoded.
      if (window.makcImageLoad) window.makcImageLoad.watch(thumbImage);
      row.querySelector('.makc-search-takeover__thumb').appendChild(thumbImage);
    }
    row.querySelector('.makc-search-takeover__name').textContent = product.title;
    row.querySelector('.makc-search-takeover__category').textContent = product.menu_category;
    if (!product.available) {
      row.disabled = true;
      row.classList.add('makc-search-takeover__row--sold-out');
      var soldOutTag = document.createElement('span');
      soldOutTag.className = 'makc-search-takeover__sold-out-tag';
      soldOutTag.textContent = 'Sold out today';
      row.appendChild(soldOutTag);
    } else {
      row.addEventListener('click', function () {
        openProductSheet(product.id);
      });
    }
    return row;
  }

  // "See all in [Category]" -- confirmed via Figma (Search / See All
  // Row, node 2047:602 light / 2049:607 dark). Cloned from the real
  // <template> in the liquid file rather than built as an HTML string
  // here, so the caret icon renders from the one real makc-icon-
  // caret-up.liquid source instead of a second inline SVG copy (see
  // the liquid template's own comment). Tapping it sets the input's
  // value to the full, correctly-cased category name and dispatches a
  // real 'input' event on the same field -- this re-enters the exact
  // listener below as if the customer had typed the rest of the word
  // themselves, landing on the already-shipped exact-category-match
  // bypass (unlimited results), not a second/parallel code path.
  function renderShowAllRow(categoryName) {
    if (!showAllTemplate) return null;
    var row = showAllTemplate.content.firstElementChild.cloneNode(true);
    row.querySelector('.makc-search-takeover__show-all-text').textContent = 'See all in ' + categoryName;
    row.addEventListener('click', function () {
      input.value = categoryName;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    return row;
  }

  if (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();

      if (clearButton) clearButton.hidden = query.length === 0;

      if (query === '') {
        showState('popular');
        return;
      }

      var matches = matchProducts(query);

      if (matches.length === 0) {
        showState('no-results');
        return;
      }

      if (typingResults) {
        typingResults.innerHTML = '';
        matches.forEach(function (product) {
          typingResults.appendChild(renderResultRow(product));
        });
        var showAllCategory = getUniqueCategoryPrefixMatch(query);
        if (showAllCategory) {
          var showAllRow = renderShowAllRow(showAllCategory);
          if (showAllRow) typingResults.appendChild(showAllRow);
        }
      }
      showState('typing');
    });
  }

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      if (input) {
        input.value = '';
        input.focus();
      }
      clearButton.hidden = true;
      showState('popular');
    });
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', open);
  });

  // Takeover landing page (sections/makc-open-on-load.liquid in search
  // mode, the admin-assigned Search page): open as soon as the page
  // loads. The page body beneath carries a fallback trigger, wired
  // above like any other. Read once, at init.
  if (document.querySelector('[data-makc-open-on-load="search"]')) {
    open();
  }

  // Mirrors assets/makc-cart-shell.js's own open-on-load close-to-Menu
  // handling -- see that file's comment for the full reasoning. Reads
  // the same pages['menu'].url computed on the landing section's root
  // (sections/makc-open-on-load.liquid) rather than duplicating the
  // lookup here; empty/missing just closes, same guard as that file.
  function openOnLoadMenuUrl() {
    var landing = document.querySelector('[data-makc-open-on-load="search"]');
    return landing ? landing.getAttribute('data-makc-open-on-load-menu-url') : '';
  }

  // Shared by both dismissal affordances: the close X, and the backdrop
  // click wired below (the backdrop only exists from 768px up, where
  // this becomes a top-anchored modal -- see the 768px block in
  // assets/makc-search-takeover.css). On the search landing page the
  // close X navigates to Menu rather than leaving an empty page behind,
  // and a backdrop click has to do the same thing for the same reason.
  function dismiss() {
    var menuUrl = openOnLoadMenuUrl();
    close();
    if (menuUrl) window.location.href = menuUrl;
  }

  if (closeButton) {
    closeButton.addEventListener('click', dismiss);
  }

  // Bound to the real backdrop element, not inferred from the click
  // target: display: none below 768 makes it unreachable there, and
  // clicks inside the panel can never reach it, so no target check or
  // matchMedia guard is needed.
  var backdrop = takeover.querySelector('[data-makc-search-backdrop]');
  if (backdrop) {
    backdrop.addEventListener('click', dismiss);
  }
})();
